import { SvgIcon, SvgIconProps } from "@mui/material";

export const UploadIcon2 = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
        <path
          stroke="currentColor"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          d="M17.5 12.5v3.333a1.666 1.666 0 0 1-1.667 1.667H4.167A1.667 1.667 0 0 1 2.5 15.833V12.5M14.167 6.667 10 2.5 5.833 6.667M10 2.5v10"
        />
      </svg>
    </SvgIcon>
  );
};
